import React, { FC } from 'react';
import Screenshot from '../../images/onefam-homepage.jpg';

export interface SeoProps {}

const Seo: FC<SeoProps> = ({}) => {
  const metaDescription = 'Integrate the culture into the community.';
  const defaultTitle = 'ONEFAM Barbershop';

  return (
    <>
      <title>{defaultTitle}</title>
      <meta name='description' content={metaDescription} />
      <meta property='og:title' content={defaultTitle} />
      <meta property='og:description' content={metaDescription} />
      <meta property='og:type' content='website' />
      <meta name='og:image' content={Screenshot} />
      <meta property='og:image:width' content='1000' />
      <meta property='og:image:height' content='1000' />
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:creator' content={``} />
      <meta name='twitter:title' content={defaultTitle} />
      <meta name='twitter:description' content={metaDescription} />
      <meta name='robots' content='max-image-preview:large' />
      <script className='structured-data' type='application/ld+json'>
        {`{
            "@context" : "https://schema.org",
            "@type" : "WebSite",
            "name" : "ONEFAM Barbershop",
            "url" : "https://onefambarbershop.com/",
            "alternateName": ["OneFam", "Onefam", "OneFam Barbershop", "Onefam Barbershop", "ONEFAM Shop", "OneFam Shop", "Onefam shop"],
        }`}
      </script>
    </>
  );
};

export default Seo;
